const ROLES = {
  ADMIN: { label: 'Admin', value: 'ADMIN' },
  SENIOR_METADATA_CURATOR: {
    label: 'Senior Metadata Curator',
    value: 'SENIOR_METADATA_CURATOR',
  },
  METADATA_CURATOR: { label: 'Metadata Curator', value: 'METADATA_CURATOR' },
  LEARNER: { label: 'Learner', value: 'LEARNER' },
  CURATOR: { label: 'Curator', value: 'CURATOR' },
  KEYWORD_CURATOR: { label: 'Keyword Curator', value: 'KEYWORD_CURATOR' },
}

export default ROLES
